import { createSharedSelector, createSharedState } from 'preact-shared-state-hook'
import type { CurrentFolderOwner, CurrentFolderUser } from '../../../server/src/models'
import { URL_API_CURRENT_USER, URL_API_FOLDER_CURRENT_USER } from '../../../server/src/urls'

const [useCurrentUser, setCurrentUser] = createSharedState<CurrentFolderUser>()

export const loadCurrentUser = async (folderId?: string) => {
  const response = await fetch(folderId ? URL_API_FOLDER_CURRENT_USER(folderId) : URL_API_CURRENT_USER)
  const currentUser = response.ok && ((await response.json()) as CurrentFolderUser)
  currentUser && currentUser.uid && setCurrentUser(currentUser)
  return response
}

export const getCurrentUser = useCurrentUser.snapshot

export const useCurrentUserTenant = createSharedSelector([useCurrentUser], currentUser =>
  !currentUser?.guest && currentUser?.primary_tenant_id ? currentUser.tenants?.[currentUser.primary_tenant_id] : undefined,
)

export const updateCurrentUser = (update: (currentUser: CurrentFolderOwner) => CurrentFolderOwner) =>
  setCurrentUser(currentUser => (!currentUser || currentUser.guest ? currentUser : update(currentUser)))

export { useCurrentUser }
